import { path, prop } from "ramda";
export var selectActiveProject = function selectActiveProject(store) {
    var state = store.ProjectsReducer;
    var activeProjectUid = prop("activeProjectUid", state);
    return activeProjectUid && path(["projects", activeProjectUid], state);
};
